var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',_vm._l((_vm.cardData.exercises),function(exercise){return _c('Exercise',{key:exercise.id,attrs:{"exercise":exercise,"exerciseData":_vm.exerciseData[exercise.id],"summaryMode":"true"}})}),1)}
var staticRenderFns = []

export { render, staticRenderFns }